export default function Pull_from_GitHub() {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-4">Pull from GitHub</h1>

      <p className="mt-4 text-gray-500 text-sm">Path: /git/github/pull</p>
    </div>
  );
}
